import { useTranslation } from 'next-i18next'
import styles from './OrganizerLatestTrophies.module.scss'
import { FC } from 'react'
import { TrophyGallery } from '~/components/TrophyGallery/TrophyGallery'
import { ComponentTrophyDto } from '~/modules/Products/Infrastructure/Dtos/ComponentTrophyDto'

interface Props {
  trophies: ComponentTrophyDto[]
}

export const OrganizerLatestTrophies: FC<Props> = ({ trophies }) => {
  const { t } = useTranslation('latest_trophies')

  return (
    <div className={ styles.organizerLatestTrophies__container }>
      <div className={ styles.organizerLatestTrophies__headerTitle }>
        { t('organizer_latest_trophies_header_title') }
      </div>

      <TrophyGallery trophies={ trophies }/>
    </div>
  )
}
